import * as z from "zod/v4";
import { ConversationTagSource } from "./conversation-tags/conversation-tag-record";
import { CustomerTagSource } from "./customer-tags/customer-tag-record";
import { PillTheme } from "./pill-theme";

export enum TagKind {
  FULFILLMENT_GROUP = "fulfillment-group",
  CONVERSATION = "conversation",
  CUSTOMER = "customer",
  RETURN = "return",
}

export enum FulfillmentGroupTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
}

export enum ReturnTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
  FLOW = "flow",
}

export const TagKindSchema = z.enum(TagKind);
export const PillThemeSchema = z.enum(PillTheme);
export const CustomerTagSourceSchema = z.enum(CustomerTagSource);
export const ConversationTagSourceSchema = z.enum(ConversationTagSource);
export const FulfillmentGroupTagSourceSchema = z.enum(
  FulfillmentGroupTagSource,
);
export const ReturnTagSourceSchema = z.enum(ReturnTagSource);

const TagSchema_ = z.object({
  name: z.string(),
  numericId: z.number().nullish(),
  pillTheme: PillThemeSchema,
  source: z.union([
    CustomerTagSourceSchema,
    ConversationTagSourceSchema,
    FulfillmentGroupTagSourceSchema,
    ReturnTagSourceSchema,
  ]),
  kind: TagKindSchema,
});
export const TagSchema: z.ZodType<Tag> = TagSchema_;
export type Tag = z.infer<typeof TagSchema_>;
